module.exports = __webpack_public_path__ + "static/mobile-blank-screen-464a409d3fda60ff6a6b096e02c1a149.png";